/** 定向分享注册归因的固定渠道来源。 */
export const REPORT_SHARE_CHANNEL_SOURCE = 'ip_share_invite_register';

/** 支持的定向分享邀请来源代码。 */
export const REPORT_SHARE_INVITATION_CODES = [
    'ip_searching_novelty_search',
    'ip_searching_fto',
    'ip_searching_design_fto',
] as const;

/** 定向分享链接的传播媒介。 */
export type ReportShareMediaType = 'email' | 'link';

/** 定向分享邀请对应的 Agent 来源代码。 */
export type ReportShareInvitationCode = typeof REPORT_SHARE_INVITATION_CODES[number];

/**
 * 分享链接注册归因信息。
 */
export interface ShareLinkAttribution {
    /** 分享链接的传播媒介。 */
    mediaType: ReportShareMediaType;
    /** 报告创建者用户 ID。 */
    inviterId: string;
    /** 当前报告所属 Agent 的稳定来源代码。 */
    invitationCode: ReportShareInvitationCode;
}

/** 判断值是否为支持的定向分享传播媒介。 */
export function isReportShareMediaType(value: unknown): value is ReportShareMediaType {
    return value === 'email' || value === 'link';
}

/** 判断值是否为支持的定向分享邀请来源代码。 */
export function isReportShareInvitationCode(value: unknown): value is ReportShareInvitationCode {
    return REPORT_SHARE_INVITATION_CODES.includes(value as ReportShareInvitationCode);
}
